import React,{useEffect,useState} from 'react';
import { useSearchParams } from "react-router-dom";
import Moment from 'react-moment';
import Axios from '../../lib/axios/axiosInstance';

const MyReturnDetails = () => { 
  const [searchParams, setSearchParams] = useSearchParams();
  const [returnDetails, setReturnDetails] = useState(false);

  useEffect(async () => {
      const refnum = searchParams.get("refnum")
      if (refnum) {
          // Get return request details
          // api/account/salesreturn/:refnum
          await Axios.get(`/account/salesreturn/${refnum}`)
              .then(function (response) {
                  if (response && response.data?.data) {
                    setReturnDetails(response.data?.data)
                  }
              })
      }
  }, [searchParams])

    return (
      <section className="main-container col1-layout">
      <div className="main container">
        <div className="col-main">
          <div className="shopping-cart-inner">
            <div className="page-content">
              
              <div className="page-content checkout-page">
                <div className="box-border">
                  
                  <h2>Refund/Exchange Summary</h2>
                  <h5><strong>Refnum:</strong> {searchParams && searchParams.get("refnum")}</h5>
                  <h5><strong>Refund Date:</strong> N/A</h5>
                  <h5><strong>Refund Type:</strong> N/A</h5>
                  <br/>
  
                  <ul className="step">
                    <li style={{width: "25%"}} className={returnDetails?.log && returnDetails.log.length==1 ? "current-step" : ""}><i className="fa fa-spinner"></i><span> Refund Initiated</span></li>
                    <li style={{width: "25%"}} className={returnDetails?.log && returnDetails.log.length==2 ? "current-step" : ""}><i className="fa fa-clipboard"></i><span> Refund Under Review</span></li>
                    <li style={{width: "25%"}} className={returnDetails?.log && returnDetails.log.length==3 ? "current-step" : ""}><i className="fa fa-tasks"></i><span> Refund Processing</span></li>
                    <li style={{width: "25%"}} className={returnDetails?.log && returnDetails.log.length==4 ? "current-step" : ""}><i className="fa fa-check"></i><span> Refunded</span></li>
                  </ul>
                  
                  <div className="page-title">
                    <div className="heading-counter warning" style={{border: "1px solid #82aad7",color: "#3c5376"}}>
                      {returnDetails?.log && returnDetails.log.map((data,i)=>{
                        return (
                          <><small key={i} style={{paddingRight: "10px"}}><Moment date={data.createdat} format="YYYY-MM-DD | HH:mm:ss"/></small><span><strong>{data.detail}</strong></span><br/></>
                        )
                      })}
                      {/* <a href="#">View Less</a> */}
                    </div>
                  </div>
                  <div className="order-detail-content table-responsive">
                    <table className="table table-bordered jtv-cart-summary">
                      <thead>
                        <tr>
                          <th className="cart_product">Product</th>
                          <th>Description</th>
                          <th>Unit price</th>
                          <th>Qty</th>
                          <th>Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="cart_product"><a href="#"><img src="images/products/img02.jpg" alt="Product"/></a></td>
                          <td className="cart_description"><p className="product-name"><a href="#"> TruSens Z-1000 Air Purifier (FOC Carbon & Hepa Filter) </a></p>
                            <small className="cart_ref">Doc No : DN2203506</small><br/>
                          </td>
                          <td className="price"><span>S$193.46</span></td>
                          <td className="price"><span>1</span></td>
                          <td className="price"><span>Item is not fully functioning.</span></td>
                          
                        </tr>
                      </tbody>
                      <tfoot>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <div className="box-border">
                  <div className="box-account">
                    <div className="page-title">
                      <h2>Delivery Note</h2>
                    </div>
                    <div className="col2-set">
                      <div className="col-1">
                        <p><strong>Remarks:</strong> <br/>
                        </p>
                      </div>
                    </div>
                    <hr/>
                    <div className="page-title">
                      <h2>Credit Refund Note</h2>
                    </div>
                    <div className="col2-set">
                      <div className="col-1">
                        <p><strong>Remarks:</strong> <br/>
                        </p>
                      </div>
                    </div>
                    <hr/>
                    <div className="page-title">
                      <h2>Return</h2>
                    </div>
                    <div className="col2-set">
                      <div className="col-1">
                        <p><strong>Remarks:</strong> <br/>
                        </p>
                      </div>
                    </div>
                    <hr/>
                  </div>
                </div>
                <div className="cart_navigation">
                  <button className="button btn-proceed-checkout" title="Proceed to Checkout" type="button"><span>Back to Returns & Exchange</span></button>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    )
}

export default MyReturnDetails